// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ApiRequest } from "_core/apis/ApiRequest";
import { setMasterData } from "_core/slices/datas/MasterSlice";
import { setApiTimestamp, setTransactionData, deleteTransactionData, mergeTransactionData } from "_core/slices/datas/TransactionSlice";


const AdminUpdateUserPromptApi = () => {
    const dispatch = useDispatch();

    // API固有の設定、URLとリクエスト
    const url = "/admin/update_user_prompt";

    /**
     * API実行
     * @param {File} promptFile プロンプトを記載したファイル
     * @param {number} deleteTAssetId 削除するアセットID
     * @returns リクエスト結果
     */
    const ExecAdminUpdateUserPromptApi = async (promptFile, deleteTAssetId) => {

        // 必要なリクエストを定義
        const requestParams = {};
        const requestBinaryParams = {
            user_prompt: {
                file: promptFile,
                filename: promptFile.name
            }
        }

        let response = null;
        let error = null;

        // console.log(url + "API開始");
        try {
            response = await ApiRequest({ url:url, requestParams:requestParams, requestBinaryParams:requestBinaryParams });
            // console.log(response);
        } catch (e) {
            // console.log(e);
            error = e;
        } finally {
            // console.log(url + "　API終了");
        }

        // レスポンスがあれば、データ更新
        if (response !== null && response.error_code === 0) {
            dispatch(setApiTimestamp(response['now_time']));
            if (response['t_asset'] != null) {
                dispatch(mergeTransactionData({
                    tAssetList: [response['t_asset']]
                }));
            }
            if (response['t_user'] != null) {
                dispatch(setTransactionData({
                    tUser: response['t_user']
                }));
            }
            if (deleteTAssetId > 0) {
                dispatch(deleteTransactionData({
                    tAssetList: [deleteTAssetId]
                }));
            }
        }

        return { response, error };
    };

    return ExecAdminUpdateUserPromptApi;
};

export default AdminUpdateUserPromptApi;